<template>
    <div class="table-responsive">
        <h4>Journal d'activités
            <a v-if="isUserRolesAuthorized" @click="computedLinkToDownloadCsv()" target="_blank" class="btn btn-xs btn-success">
                <i class="fa fa-share-square-o"></i>
                Exporter
            </a>
        </h4>
        <table class="table table-hover table-condensed table-detailed search-table" id="detailedTable">
            <thead>
                <tr>
                    <th class="small-cell">Date</th>
                    <th>Action</th>
                    <th>Utilisateur</th>
                    <th class="small-cell">Solde de points</th>
                    <th>Commentaires</th>
                    <th class="small-cell">Commande associée</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(activity, aIndex) in orderedActivities" :key="aIndex">
                    <td>{{ formatDateHour(activity.created_at) }}</td>
                    <td>{{ activity.decoded_type }}</td>
                    <td>{{ activity.user.email }}</td>
                    <td>{{ activity.subscription_new_points_count }}</td>
                    <td>{{ activity.comments || '-' }}</td>
                    <td>{{ getObjectProperty(activity, 'suborder.suborderable.ihrez') || '-' }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import objectManipulation from 'mixins/objectManipulation'
import dateFormatting from 'mixins/dateFormatting'
import user from 'mixins/user'
import cookies from 'cookiesjs'

export default {
    name: 'activityLog',

    props: [
        'activities',
        'lpsId'
    ],

    mixins: [
        objectManipulation,
        dateFormatting,
        user
    ],

    computed: {
        orderedActivities () {
            return _.reverse(this.activities)
        }
    },

    methods: {
        computedLinkToDownloadCsv () {
            const params = {
                token: cookies('token')
            }

            const urlParamsForPHP = $.param(params)

            window.location = `${__API_URL__}/loyalty_program_subscriptions/${this.lpsId}/activity_log/export?${urlParamsForPHP}`
        }
    }
}
</script>

<style lang="scss" scoped>
h4 {
    .btn {
        margin: 0 15px;
    }
}

.small-cell {
    width: 150px;
}
</style>



// WEBPACK FOOTER //
// client/components/Customer/LoyaltyProgram/ActivityLog.vue